<template>
  <div class="content al_c">

<!--     <s-location title="로그인" hide-subtitle /> -->
    <s-location notice title="마이페이지"/>

    <div class="login_wrap">
	      <!-- <h3><span class="pc">대한변호사협회 </span> <p>변호사 출입관리 시스템</p> </h3> -->
      <h3><p>{{ user.id }} 비밀번호 확인</p> </h3>

      <!-- <div style="line-height: 30px;">
        {{ user.id }} 의 비밀번호 입력
      </div> -->

      <input v-model="login.pw"   ref="pw"       type="password" title="비밀번호 입력" placeholder="비밀번호 입력" name="kwd" id="topKwd" class="tplaceholder" @keydown.enter="doCheckPw" :rules="[rules.min]" />
      <div class="btn xl blue01" @click="doCheckPw">확인</div>
      <div class="btn xl" style="margin-top: 20px;" @click="$router.push('/qrcode/qrcode_scan')">취소</div>
      <div class="btn xl" style="margin-top: 20px;" @click="$router.push(_config.LOGOUT_PATH)">로그아웃</div>
    </div>


  </div>
</template>


<script>
let ui
import { mapGetters } from 'vuex'
export default {
  created() {
    ui = this.$ui;
  },
  mounted() {
    // this.$refs.id.$el.getElementsByTagName("input")[0].focus()
    this.$refs.pw.focus()
  },
  data() {
    return {
      err_msg: '',
      login: {
        id: '',
        pw: '',
      },
      rules: {
        alphabet : v=> /[a-zA-Z]+/.test(v) || '영문을 포함하여 입력하세요.',
        min: v => v.length >= 3 || '3자 이상 입력하세요.',
      },
      x: [],
      test_login :1,
    }
  },
  computed: {
    _smenu() { return this.$mq == 'mobile' ? this.mobileSmenu : this.$route.meta.smenu },
    ...mapGetters('session', ['user', 'isLogin']),
    path() { return this.$route.path },
    loginTypeName() {
      switch (this.$store.state.session.user.type) {
        case "self": return "개인변호사"
        case "member": return "소속"
        case "master": return "마스터"
      }
      return ""
    },
  },
  watch: {
    err_msg() { // sso 오류메세지 출력
      this.err_msg && ui.alert_error(this.err_msg)
    }
  },
  beforeRouteEnter (to, from, next) {

    if (to && to.query && to.query.mode == 'sso') {

      console.log("to.query = ", to.query);

      // mode: "sso"
      // sso_no: "5"
      // sso_key: "5vjzamz2mcv9tur6blhpocpww9hvyx4rk290hjub5tw4ub96k4"
      T.httpGet("/auth/sso_recv", to.query,
        ret=>{
          console.log(ret.data)
          if (ret.data) {
            const {status, msg, token, message} = ret.data
            if (status == 'OK') {
              next(vm => {
                vm.$store.commit("session/SET_TOKEN", token) // 로그인 완료 처리
                vm.$router.replace('/main/main')
              })
            } else {
              const err_msg = msg || message // SSO 오류는 msg 에 프로시져 자체 오류는 message 로 넘어온다..
              next(vm => vm['err_msg'] = err_msg) // 오류를 반환했을때
            }
          }
        }, null, v=>next()) // 어떤 경우라도 화면은 나와야 하니깐..

    } else if (to && to.query && to.query.mode == 'login_switch') {

      console.log("to.query = ", to.query);

      // mode: "login_switch"
      // id: "seoulbar03"
      T.httpGet("/auth/login_switch", to.query,
        ret=>{
          console.log(ret.data)
          if (ret.data) {
            const {status, msg, token, message} = ret.data
            if (status == 'OK') {
              next(vm => {
                vm.$store.commit("session/SET_TOKEN", token) // 로그인 완료 처리
                vm.$router.replace('/') // 메인으로 이동
              })
            } else {
              const err_msg = msg || message // SSO 오류는 msg 에 프로시져 자체 오류는 message 로 넘어온다..
              next(vm => vm['err_msg'] = err_msg) // 오류를 반환했을때
            }
          }
        }, null, v=>next()) // 어떤 경우라도 화면은 나와야 하니깐..

    } else {
      return next()
    }

  // beforeRouteEnter(to, from, next) {
  //     next(vm => {
  //       if(from.path === '/somePath'  && vm.someData.length > 0) {
  //         vm.$router.push({ name: 'some_name'})
  //       } else {
  //         vm.$router.push({ name: 'another_name'})
  //       }
  //     })
  //   },

    // https://router.vuejs.org/kr/guide/advanced/data-fetching.html#%ED%83%90%EC%83%89-%ED%9B%84-%EA%B0%80%EC%A0%B8%EC%98%A4%EA%B8%B0

    // getPost(to.params.id, (err, post) => {
    //   next(vm => vm.setData(err, post))
    // })
    // next()
  },
  methods: {
    mlogin(id, pw) {
      this.login.id = id
      this.login.pw = pw
      this.doCheckPw()
    },
    doCheckPw() {


      ui.httpGet('/mypage/pw_confirm', this.login,
        ret => {
          // const {tot_rows, tot_pages, pgsize, page} = ret.data.rs1[0]
          console.log("ret.data", ret.data);
          if (!ret.data)
            return

          // const {status, token, user, msg} = ret.data;
          const {status, token, msg} = ret.data;
          if (status == "OK") {
            console.log("로그인 폼에서 로그인 완료 처리");
            // this.$store.commit("session/SET_TOKEN", token);
            this.$router.push('/mypage/myinfo')
            // this.$router.push(this.$route.query.redirect || '/')
            return
          } else {
            // const cmt = T.contains(msg, '가입승인') ? msg : `등록된 아이디가 아니거나 비밀번호가 일치하지 않습니다.`
            const cmt = msg
            this.login.pw = ''
            ui.alert(cmt, "로그인 실패", {color: 'red', width: 518})
          }

        }, null, v=>this.loading = false)

    }
  },
}
</script>
<style scoped>

  /*-----------------------------------------------------------------------------------------------
    LOGIN :: 로그인
  -------------------------------------------------------------------------------------------------*/
  .login_wrap { display: inline-block; width: 100%; max-width: 480px; margin: 50px auto 20px auto; position:relative; padding: 35px 45px; border: 2px solid #777; font-size: 16px; vertical-align: top; box-sizing: border-box; text-align: left; border-radius: 5px;}
  .login_wrap h2 { margin-bottom:50px; }
  .login_wrap h2 em{ font-size:22px; color:#666; }
  .login_wrap h3 { font-size : 18px;  margin-bottom:10px;}
  .login_wrap h3 p{ color:#064680; margin-top:10px; font-size: 22px;}
  .login_wrap input[type="text"], .login_wrap input[type="password"]{ width: 100%; height: 48px; padding: 11px 70px 11px 11px; font-size:16px; font-weight:700; box-sizing: border-box; background-color: #f3f3f3; margin-bottom:10px; }
  .login_wrap .btn { margin:0px 0 5px 0;}
  .info_user { font-size:13px;}

  .sel_mem li { width:30%; padding: 15px; font-size:14px;}
  .sel_mem li .tit{font-size:15px;}

  .sel_mem li .cont { font-size:14px; font-weight: normal}


</style>